import PropTypes from 'prop-types'

import { Chip, chipPropTypes } from '../../elements'
import styles from './ChipList.module.css'

export const ChipList = ({ title, items }) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>{title}</p>
      <div className={styles.list}>
        {items.map((item) => (
          <Chip key={item.id} {...item} />
        ))}
      </div>
    </div>
  )
}

ChipList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      ...chipPropTypes
    })
  ).isRequired
}
